module.exports = __webpack_public_path__ + "img/poster.b6e7d861.png";